import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// Registro de componentes globais do core
import InputAno from 'core/components/InputAno.vue'
import ComprovantePagamentoModal from 'core/components/ComprovantePagamentoModal.vue'
import InputSelecionaBanco from 'core/components/InputSelecionaBanco.vue'
import RevisaoDadosBancarios from 'core/components/RevisaoDadosBancarios.vue'
import DadosContato from 'core/components/DadosContato.vue'
import DadosEndereco from 'core/components/DadosEndereco.vue'
import DocumentoEdit from 'core/components/DocumentoEdit.vue'
import DocumentoModal from 'core/components/DocumentoModal.vue'
import DocumentoGrid from 'core/components/DocumentoGrid.vue'
import AgendaParcela from 'core/components/AgendaParcela.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})
Vue.component('InputAno', InputAno)
Vue.component('ComprovantePagamentoModal', ComprovantePagamentoModal)
Vue.component('InputSelecionaBanco', InputSelecionaBanco)
Vue.component('RevisaoDadosBancarios', RevisaoDadosBancarios)
Vue.component('DadosContato', DadosContato)
Vue.component('DadosEndereco', DadosEndereco)
Vue.component('DocumentoEdit', DocumentoEdit)
Vue.component('DocumentoModal', DocumentoModal)
Vue.component('DocumentoGrid', DocumentoGrid)
Vue.component('AgendaParcela', AgendaParcela)
